import { Box, Card, CardHeader, Stack } from '@mui/material'
import { memo } from 'react'

import { Label } from 'src/components/shared/label'
import { percentageOfCompletion } from 'src/util/number.helpers'
import { membershipLabel } from 'src/util/staking/staking.helpers'
import { formatTicks } from 'src/util/string.helpers'
import MembershipLevel from './MembershipLevel'
import PurchaseStatusButton from '../shared/purchaseStatus/PurchaseStatusButton'

const MembershipLevels = ({ t, userTier, tiers }) => {
  return (
    <Card sx={{ width: '100%' }}>
      <Stack
        direction='row'
        sx={{ justifyContent: 'space-between', pt: 3, px: 3 }}
      >
        <CardHeader
          title={t('brand:staking.membership-status-progress')}
          sx={{ p: 0 }}
        />
        <PurchaseStatusButton t={t} />
      </Stack>
      <Box
        sx={{
          p: 3,
          gap: 3,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {tiers.map(({ id, name, fiatThreshold }, index) => {
          const isTierQuartz = id === 1
          const completed = isTierQuartz
            ? 100
            : percentageOfCompletion(userTier.totalFiatValue, fiatThreshold)
          return (
            <MembershipLevel
              key={index}
              t={t}
              completed={completed}
              id={id}
              userTierId={userTier.tier.id}
              title={membershipLabel({ t, id, name })}
              label={
                fiatThreshold > 0
                  ? t('brand:staking.min-staked-value', {
                      value: formatTicks(fiatThreshold)
                    })
                  : t('brand:staking.basic-membership-no-min')
              }
              infoBadge={
                id === userTier.tier.id && (
                  <Label color='primary'>
                    {t('brand:staking.current-status')}
                  </Label>
                )
              }
            />
          )
        })}
      </Box>
    </Card>
  )
}

export default memo(MembershipLevels)
